import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

export const useDebounce = ({ value: initialValue, delay = 200 }) => {
  const [value, setValue] = useState(initialValue);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounced = useCallback(
    debounce((v) => {
      setValue(v);
    }, delay),
    [delay, setValue],
  );

  useEffect(
    () => () => {
      debounced.cancel();
    },
    [debounced],
  );

  return [value, debounced];
};
